{
  "title": "Partner portal",
  "subtitle": "Share your code and track your commissions.",
  "email": "Email",
  "password": "Password",
  "signIn": "Sign in to the portal",
  "signOut": "Sign out",
  "error": "Could not complete. Check your access and try again.",
  "retry": "Try again",
  "codeTitle": "Your partner code",
  "codeBrief": "Share this single code. On monthly and annual plans your customer gets {{days}} free trial days in total and you earn {{total}}% recurring commission.",
  "codeBriefNormal": "Share this single code. On monthly and annual plans your customer gets {{days}} free trial days in total and you earn {{total}}% recurring commission ({{rate}}% + VAT).",
  "codeLoading": "Loading your code…",
  "codeUnavailable": "Couldn't load your code right now.",
  "codeRetry": "Try loading the code again",
  "codeSuspended": "Sharing the code is unavailable while the partner account is not active.",
  "copyCodeAction": "Copy code",
  "codeLabel": "Code",
  "linkLabel": "Share link",
  "linkHelp": "Anyone who registers through this link gets your code pre-filled.",
  "copyLinkAction": "Copy link",
  "copyCode": "Copy code for {{name}}",
  "copied": "Copied",
  "copyFailed": "Couldn't copy. Select and copy the text shown.",
  "inactiveChip": "Inactive account",
  "inactiveNotice": "Your partner account is not active yet. You can check the status, but sharing your code only becomes available after AllDrivers approval. This is independent of Stripe payment setup.",
  "termsTitle": "Programme terms",
  "termsFixed": "One set of terms for every partner, set by AllDrivers. Not editable.",
  "termsCustomer": "Your customer receives",
  "termsMonthly": "Monthly plans: {{days}} free trial days in total, counted from the explicit subscription enrolment (registration alone does not start it).",
  "termsAnnual": "Annual plans: {{days}} free trial days in total, same as monthly plans.",
  "termsNoCoupons": "No coupons or additional referral discounts.",
  "termsEarn": "What you earn",
  "termsExempt": "VAT-exempt regime: 20% of the software subscription amount collected (the total).",
  "termsNormal": "Normal VAT regime: 16.26% (displayed value) plus 23% VAT; a total of 20% with cent rounding.",
  "termsRecurring": "Recurring while the customer keeps eligible active software subscriptions, including added driver licences.",
  "yourRegime": "Your VAT regime",
  "termsVatNormal": "In the normal regime the 20% already includes VAT: 16.26% plus 23% VAT. Every amount in the portal is that VAT-inclusive total. Your regime is on your partner record; contact AllDrivers to correct it.",
  "termsVatExempt": "Amounts without VAT; your regime is on your partner record. Contact AllDrivers to correct it.",
  "termsVatUnknown": "Your VAT regime could not be confirmed yet. It is not inferred from this page.",
  "termsExcludedTitle": "Not counted for commission",
  "termsExcluded": "GPS equipment, activation/setup and shipping.",
  "termsMaturity": "Each commission is available as soon as the customer's payment is confirmed and is transferred automatically to your Stripe balance. Stripe pays that balance out to your bank once a month, on day {{day}}; arrival depends on Stripe and your bank.",
  "termsOneBenefit": "The benefit applies once per customer, on the first subscription, whatever the product. It does not stack.",
  "metricsTitle": "Your commissions",
  "metricsLoading": "Loading commissions…",
  "metricsError": "Couldn't load the commissions.",
  "metricsEmpty": "No referrals yet. When a customer registers with your link or code, it shows up here.",
  "metricsReferrals": "Referred customers",
  "metricsPaying": "Customers with payments",
  "stageMaturing": "Awaiting payment confirmation",
  "stagePayable": "Available, awaiting transfer",
  "stageInPayout": "Processing",
  "stagePaid": "Transferred to your Stripe balance",
  "stageOffsetDeducted": "Deducted for refunds",
  "stageCreditAdded": "Credited for reversed disputes/refunds",
  "stageUnderReview": "Under review",
  "stageReconciled": "Sent after reconciliation",
  "metricsMaturity": "Each commission is available as soon as the customer's payment is confirmed.",
  "metricsMaturityUnknown": "Maturity depends on the customer's confirmed payment.",
  "metricsVatNormal": "Totals with VAT included (16.26% + 23% VAT = 20%).",
  "metricsVatExempt": "Amounts without VAT.",
  "metricsVatUnknown": "Your VAT regime could not be confirmed yet. The amounts shown are not adjusted by any inferred VAT.",
  "metricsNotBank": "\"Sent by AllDrivers\" means a transfer to your Stripe balance — it does not confirm the money reached your bank. Check the Stripe Express dashboard.",
  "metricsPendingOffset": "Compensations to apply",
  "metricsPendingOffsetNote": "Refund or dispute compensations are deducted from future commissions — they are never an automatic bank debit.",
  "connectTitle": "Get paid (Stripe)",
  "connectUnavailable": "Stripe payments setup is not available in this environment. You can keep copying and sharing your code; qualifying commissions stay pending until verification.",
  "connectStart": "Set up payments",
  "connectContinue": "Continue setup",
  "connectTestMode": "Test mode",
  "connectRequirements": "Items flagged by Stripe: {{count}}",
  "connectStep1": "Fill in the data on Stripe's secure form",
  "connectStep2": "Stripe verifies the data",
  "connectStep3": "Account ready to receive transfers",
  "connectRefresh": "Check status",
  "connectRefreshFailed": "Couldn't check the status now. Try again.",
  "connectOpenFallback": "Continue on Stripe",
  "connectDashboard": "Open Stripe dashboard",
  "connectDashboardHelp": "The Stripe dashboard shows your balance, transfers and bank payouts.",
  "connectDashboardFailed": "Couldn't open the Stripe dashboard now. Try again.",
  "connectKeepSharing": "You can share your code and accrue commissions before finishing this step. Only the payout depends on it.",
  "connectState_not_started": "You haven't started the Stripe setup yet. Qualifying commissions accrue, but payout only becomes available after verification.",
  "connectState_created": "Stripe account created. Finish Stripe's secure form to provide your activity details.",
  "connectState_action_required": "Stripe needs more information. Continue the setup to resolve the pending requirements.",
  "connectState_verification_pending": "Stripe is verifying your data. Payout stays blocked until verification finishes.",
  "connectState_restricted": "The account is restricted by Stripe. Resolve the pending requirements to continue.",
  "connectState_enabled": "Stripe account verified. Each commission is transferred automatically to your Stripe balance when the customer pays. Stripe pays the balance out to your bank once a month, on day 1.",
  "applyTitle": "Partner application",
  "applyIntro": "Apply to become an AllDrivers partner. You can use the account you already have; no need to create another.",
  "applyDistinct": "Approval is done by AllDrivers and is independent of the Stripe payments setup. It is not automatic.",
  "applySubmit": "Apply to become a partner",
  "applyError": "Couldn't submit the application now.",
  "applyPending": "Application submitted. It is pending approval by AllDrivers.",
  "applyPendingHelp": "While it is pending you cannot share your code. Once it is approved, the portal becomes available with the same account.",
  "applyReviewTitle": "Application under review",
  "applyActive": "Your partner account is active.",
  "applyOpenPortal": "Open the partner portal",
  "applySuspended": "Your partner account is suspended. Contact AllDrivers for details.",
  "applyRejected": "Your application was not approved.",
  "applyRejectedHelp": "If you need clarification, contact AllDrivers.",
  "applyNeedAccount": "You need an account to apply. Create one or sign in to your current account — the application uses the same identity.",
  "applyCreateAccount": "Create account",
  "applySignIn": "Sign in",
  "applyEmail": "Email",
  "applyNif": "NIF or NIPC",
  "applyVatLabel": "VAT regime",
  "applyVatNormal": "Standard regime",
  "applyVatExempt": "VAT exempt",
  "applyVatHelp": "Standard regime: 23% VAT applies. Exempt: no VAT.",
  "applyVatRequired": "Select your VAT regime.",
  "applyRequestSubmit": "Continue",
  "applySentTitle": "Check your email.",
  "applySentHelp": "If the details are correct, we sent a confirmation link to that email. Confirm it to continue your application; confirming the email does not approve the application.",
  "applyEmailInvalid": "Enter a valid email.",
  "applyNifInvalid": "Enter a valid NIF (individual) or NIPC (company), 9 digits.",
  "verifyTitle": "Email confirmation",
  "verifyWorking": "Confirming your email…",
  "verifyError": "The link is invalid or has expired. Request a new link.",
  "verifyContinue": "Back to the application",
  "buyerBenefitTitle": "Referral benefit",
  "buyerMonthly": "Monthly plans: 14 free trial days in total, starting at the explicit subscription enrolment (not at registration).",
  "buyerAnnual": "Annual plans: 14 free trial days in total, starting at the explicit subscription enrolment (not at registration).",
  "buyerExcluded": "GPS equipment, activation/setup and shipping are not included.",
  "buyerTermsNote": "Official AllDrivers terms. The benefit applies once per customer.",
  "buyerCta": "Create an account with this referral",
  "buyerNoCode": "This link doesn't carry a valid referral code. You can enter the code during registration.",
  "buyerExistingAccount": "This referral applies to new accounts only. If you already have an account, just sign in — the code cannot be added after registration.",
  "previewNotice": "Preview: referrals and benefits depend on the registration and purchase integration.",
  "previewUnavailable": "This campaign is not available.",
  "pending": "Registration and purchase integration pending.",
  "codeFieldLabel": "Referral code (optional)",
  "codeFieldHelp": "If someone gave you a code, enter it here. It can only be applied during registration, not after.",
  "codeFieldValidate": "Validate code",
  "codeFieldValid": "Code accepted: {{partner}}'s referral. It is linked to your account when you finish registering.",
  "codeFieldInvalid": "This code could not be applied: it may be invalid, inactive, or your own code.",
  "codeFieldLinkExpired": "This referral link has expired. Enter the code or continue without a referral.",
  "codeFieldCorrect": "Fix code",
  "codeFieldContinueWithout": "Continue without a referral",
  "initialCodeTitle": "Choose your code",
  "initialCodeLabel": "Referral code",
  "initialCodeHelp": "Choose once: keep the suggested code or type your own (4–32 letters or numbers, starting with a letter, without spaces; case-insensitive). Your code and link only start accepting referrals after you confirm. Only the AllDrivers team can replace your code afterwards.",
  "codePendingChoice": "Choose your code below to activate your referral link.",
  "initialCodeConfirm": "Confirm one-time choice",
  "initialCodeError": "Your choice could not be confirmed. Check the format and availability, or retry.",
  "codeFieldResolve": "Validate or correct the code, or choose to continue without a referral. You cannot add it after registration.",
  "codeFieldSessionExpired": "Your registration session expired. We are checking the code again; then submit once more.",
  "codeFieldTransient": "The code could not be validated right now.",
  "codeFieldTransientWarn": "If you continue without a code, you won't be able to add it later.",
  "codeFieldSkip": "Continue without a code",
  "signInFailed": "Incorrect email or password.",
  "emailInvalid": "Enter a valid email.",
  "emailLinkHelp": "No password, or can't remember it? Get a sign-in link by email.",
  "emailLinkSignIn": "Sign in with an email link",
  "emailLinkFailed": "We couldn't send the link right now. Please try again.",
  "emailLinkSentTitle": "Check your email.",
  "emailLinkSentHelp": "If an account exists for that email, we sent a portal sign-in link. The link works once and expires shortly.",
  "emailLinkBack": "Use a different email",
  "notPartnerYet": "Not a partner yet? Apply",
  "applyModeNew": "Create a new account",
  "applyModeExisting": "I already have an account",
  "applyPasswordConfirm": "Confirm password",
  "applyPasswordHelp": "Use at least 8 characters, not only numbers, and avoid common words or anything close to your email.",
  "applyPasswordRequired": "Enter a password.",
  "applyPasswordWeak": "Password too weak. Use at least 8 characters, not only numbers, and avoid common words or anything close to your email.",
  "applyPasswordMismatch": "The passwords don't match.",
  "applyLoginFailed": "Incorrect email or password. You can also sign in with an email link.",
  "applyAccessSentTitle": "Check your email.",
  "applyAccessSentHelp": "If an account exists for that email, we sent a sign-in link. Once signed in, continue your application.",
  "applySentBack": "Back",
  "applyAccountNif": "The NIF already on your account will be used: {{nif}}.",
  "verifyExistingAccount": "Email confirmed. This email already had an AllDrivers account, so the password you typed was not applied: keep signing in with your current password or an email link. The application is linked to that account.",
  "verifyExistingContinue": "Continue",
  "applyPasswordWhitespace": "The password can't start or end with a space.",
  "applyNifConflict": "This NIF doesn't match the NIF on your account.",
  "applyNifConflictApplication": "This NIF doesn't match the NIF on your application.",
  "verifyAccountNifReused": "The application uses the NIF already on that account, not the one you typed in the form."
}
